<button mat-button [matMenuTriggerFor]="userMenu">
  {{ user.username }}
  <mat-icon aria-label="Account"> account_circle </mat-icon>
</button>



<mat-menu #userMenu="matMenu">
  <button mat-button (click)="onLogout()" color="primary">
    <span>Sign out</span>
    <mat-icon aria-label="Exit">exit_to_app</mat-icon>
  </button>
</mat-menu>